var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetailedReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_335_772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.675 1.22498V11.3375H62.7875L52.675 1.22498Z",
    fill: "#002C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9375 15.0625V0.125H22.5375V8.375C31.15 10.825 37.475 18.75 37.475 28.1375C37.475 37.525 31.15 45.4625 22.5375 47.9V56.15H63.875V15.0625H48.9375ZM54.5375 41.2125H35.8625V37.475H54.5375V41.2125ZM54.5375 33.7375H37.725V30H54.5375V33.7375ZM54.5375 26.275H39.6V22.5375H54.5375V26.275Z",
    fill: "#002C3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7375 28.1375C33.7375 18.875 26.2 11.325 16.925 11.325C7.65 11.325 0.125 18.875 0.125 28.1375C0.125 36.775 6.675 43.9125 15.0625 44.8375V63.875H18.8V44.8499C27.2 43.9124 33.7375 36.775 33.7375 28.1375ZM11.325 33.7374H7.6V26.2625H11.3375V33.7374H11.325ZM18.8 33.7374H15.0625V18.8H18.8V33.7374ZM26.275 33.7374H22.5375V22.5375H26.275V33.7374Z",
    fill: "#47ADB2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_335_772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedReport);
export default __webpack_public_path__ + "static/media/DetailedReport.6875a05d45f5409eee0443824b4d5974.svg";
export { ForwardRef as ReactComponent };